// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"0bce365a","241":"3f0269f6","386":"3dcf31c8","475":"4adce28c","502":"ab5e74ff","988":"5c7dfe71"}[chunkId] + ".chunk.js";
};